G.PoolGroup = function(elementConstructor,argumentsArray,signal,initFill) {
	
	Phaser.Group.call(this,game);

	this._deadArray = [];
	this._elementConstructor = elementConstructor;
	this._argumentsArray = argumentsArray || [];
	this._argumentsArray.unshift(null);

	if (signal) {
		G.sb(signal).add(this.init,this);
	}

	if (initFill) {
		for (var i = 0; i < initFill; i++){
			element = new (Function.prototype.bind.apply(this._elementConstructor, this._argumentsArray));
			this.add(element);
			element.events.onKilled.add(this._onElementKilled,this);
			element.kill();

		}
	}

	this.onDestroy.add(function() {
		this._deadArray.forEach(function(child) {
			child.destroy();
		});
	}, this);

}

G.PoolGroup.prototype = Object.create(Phaser.Group.prototype);

G.PoolGroup.prototype.getFreeElement = function() {
	
	var element;

	if (this._deadArray.length > 0) {
		 element = this._deadArray.pop()
	}else {
		element = new (Function.prototype.bind.apply(this._elementConstructor, this._argumentsArray));
		element.events.onKilled.add(this._onElementKilled,this);
	}

	this.add(element);
	return element;

};

G.PoolGroup.prototype._onElementKilled = function(elem) {
	if (this !== elem.parent) return;
	this._deadArray.push(elem);
	this.removeChild(elem)

};

G.PoolGroup.prototype.init = function() {

	var elem = this.getFreeElement();
	elem.init.apply(elem,arguments);

	return elem;

};

G.PoolGroup.prototype.initBatch = function(nr) {

	for (var i = 0; i < nr; i++) {
		this.init.apply(this,[].slice.call(arguments,1));
	}

};